module.exports = __webpack_public_path__ + "static/banner-7f80394a31cda2d5a2201052ff2150a4.jpg";